import React from 'react'

import enhance from './enhance'
import { Upload } from './styles'

/**
 * File selection using react-dropzone:
 * https://react-dropzone.js.org
 * Enables file selection, wrapped with our redux form field handling.
 */
const Component = ({
  children,
  className,
  testId,

  // props passed down for react-dropzone
  drop,

  // wrapped handlers from the enhancer
  handleClick,
  handleDropAccepted,
  handleDropRejected,
  handleFileDialogCancel,

  // any other props injected by redux-form for the field
  ...reduxFormProps
}) => (
  <Upload
    className={className}
    data-testid={testId}
    {...drop}
    onClick={handleClick}
    onDropAccepted={handleDropAccepted}
    onDropRejected={handleDropRejected}
    onFileDialogCancel={handleFileDialogCancel}
    multiple={
      /**
       * Note: starting with only single file selection,
       * but can revisit and accommodate multiple selections later.
       */
      false
    }
  >
    {children(reduxFormProps)}
  </Upload>
)

Component.displayName = 'InputFileSelect'

export default enhance(Component)
